import {useLayoutEffect} from 'react';

import {useLocation} from 'react-router-dom';

import {Grid} from '@mui/material';

import {MatchCommentRow} from './MatchCommentRow';
import {MatchEventRow} from './MatchEventRow';
import {orangeColors} from '../../../../../../layouts/theme/designSystem';
import {isMatchEvent, MatchActivity} from '../../../../../../types/MatchActivity';
import {UserMention} from '../../../../../../types/UserMention';

interface Props {
  matchActivity: MatchActivity[];
  matchId: string;
  companyId: string;
  userId: string;
  userMentions: UserMention[];
}

export const MatchActivityList = ({matchActivity, matchId, companyId, userId, userMentions}: Props) => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const commentId = searchParams.get('comment');
  const getActivityKey = (activity: MatchActivity) => {
    if (isMatchEvent(activity)) {
      const {eventType, fromStatus, toStatus, authorName} = activity.activityContent;
      return `event-${activity.activityAt}-${eventType}-${fromStatus}-${toStatus ?? 'none'}-${authorName}`;
    }

    return `comment-${activity.activityContent.resourceId}`;
  };

  useLayoutEffect(() => {
    if (!commentId) return;
    const comment = window.document.getElementById(`comment-${commentId}`);

    if (comment) {
      comment.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
    } else {
      setTimeout(() => {
        const comment = window.document.getElementById(`comment-${commentId}`);

        if (comment) {
          comment.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
          });
        }
      }, 1500);
    }
  }, [commentId]);

  return (
    <Grid
      container
      flexDirection='column'
      gap={0}
      width='100%'
      bgcolor='white'
      borderRadius='8px'
      border={`1px solid ${orangeColors[3]}`}
      marginTop={4}
      p={2}
      sx={{
        maxHeight: '700px',
        overflowY: 'auto',
        flexWrap: 'nowrap',
      }}
    >
      {matchActivity.map((activity, index) => {
        if (isMatchEvent(activity)) {
          return (
            <Grid
              key={getActivityKey(activity)}
              sx={{
                pt: index === 0 ? 0 : 1,
                pb: 1,
                borderBottom: index === matchActivity.length - 1 ? 'none' : `1px solid ${orangeColors[3]}`,
              }}
            >
              <MatchEventRow event={activity} />
            </Grid>
          );
        }
        return (
          <Grid
            key={getActivityKey(activity)}
            sx={{
              pt: index === 0 ? 0 : 1,
              pb: 1,
              borderBottom: index === matchActivity.length - 1 ? 'none' : `1px solid ${orangeColors[3]}`,
            }}
          >
            <MatchCommentRow
              comment={activity}
              matchId={matchId}
              companyId={companyId}
              userId={userId}
              userMentions={userMentions}
            />
          </Grid>
        );
      })}
    </Grid>
  );
};
